module.exports = function (id) { return [':~:', id, ':~:'].join('') }